import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.TESTING)({
    component: TestingLayout,
    staticData: {
        config: {
            title: "testing",
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function TestingLayout() {
    return <Outlet />;
}
